import React from "react";
import { ScrollView, StyleSheet } from "react-native";
import { View, Text } from "react-native";

export function TargetConcerns({ targetConcerns }) {
  return (
    <View style={styles.container}>
      <Text style={styles.title}>Target Concerns</Text>
      <View style={styles.concernContainer}>
        {targetConcerns.length > 0 ? (
          targetConcerns.map((concern) => (
            <View key={concern} style={styles.concern}>
              <Text style={styles.concernLabel}>+{concern}</Text>
            </View>
          ))
        ) : (
          <Text>No target concerns</Text>
        )}
      </View>
    </View>
  );
}
  
    
  const styles = StyleSheet.create({
    container: {
      flex: 1,
      backgroundColor: '#EFE5DA',
      justifyContent: 'center',
      alignItems: 'center',
      paddingHorizontal: 20,
    },
    title: {
      fontFamily: 'DM Serif Display',
      fontSize: 30,
      fontWeight: 'bold',
      marginTop: 10,
      marginBottom: 10,
      color: '#3B1C15'
    },
    concernContainer: {
      flexDirection: 'row',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    concern: {
      width: 'fit-content',
      //backgroundColor: '#fff',
      //backgroundColor: 'rgba(255, 255, 255, 0.5)',
      borderRadius: 5,
      padding: 10,
      //margin: 3,
    },
    concernLabel: {
      fontFamily: 'DM Sans',
      fontStyle: 'normal',
      fontSize: 25,
      fontWeight: 400,
      //textAlign: 'center',
      marginBottom: 5,
      color: '#3B1C15'
    },
  });
  